import React, { FunctionComponent, useState, useEffect } from "react";
import { Grid, Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { ItemReturnDetailsTable } from "./ItemReturnData";
import { ItemExchangeDetailsTable } from "./ItemExchangeData";
import { ItemReturn } from "./ItemReturnCreate/ItemReturnPage";
import { ItemReturnVoucher } from "./ItemReturnVoucher/ItemReturnVoucher";
import { useItemReturnStyles } from "./useItemReturnStyles";
import { useStore } from "../../store";
import { api } from "../../api";
import { ItemReturnVoucherList } from "./ItemReturnVoucher/ItemReturnVoucherList";
import { ItemExchangeVoucherList } from "./ItemReturnVoucher/ItemExchangeVoucherList";
import { AuthenticationDialog } from "./ItemReturnDialogs/AuthenticationDialog";
import { BarcodeDialog } from "./ItemReturnDialogs/BarcodeDialog";
import { SnackBar } from "../SnackBar";
import { CustomerSelectDialog } from "./ItemReturnDialogs/CustomerSelectDialog";
import { Helmet } from "react-helmet-async";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};
export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export const ItemReturnMaster = () => {
  const classes = useItemReturnStyles();
  const [user] = useStore("auth", "user");
  const [value, setValue] = React.useState(0);
  const [createPermission, setCreatePermission] = useState<boolean>(false);
  const [voucherData, setVoucherData] = useState<any>();
  const [dataFlag, setDataFlag] = useState<boolean>(false);
  const [return_type, setReturnType] = useState<string>("");
  const [newdataFlag, setNewDataFlag] = useState<boolean>(false);
  const [printDetails, setPrintDetails] = useState<any>();
  const [exchangePrintDetails, setExchangePrintDetails] = useState<any>();
  const [openBarcodeDialog, setOpenBarcodeDialog] = useState(false);
  const [rePrint, setRePrint] = useState(false);
  const [openAuthenticationDialog, setOpenAuthenticationDialog] = useState<
    boolean
  >(false);
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [itemReturnStatus, setItemReturnStatus] = useState<string>("");
  const [isOpenCustomerSelector, setOpenCustomerSelector] = useState<boolean>(
    false
  );
  const [customer_Type, setCustomer_type] = useState<string>("C");
  useEffect(() => {
    const itemReturnPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 2
    );
    if (user.is_super_admin === true) {
      setCreatePermission(true);
    } else {
      if (itemReturnPermission) {
        if (itemReturnPermission.is_add === true) {
          setCreatePermission(true);
        }
      }
    }
  });
  const resetCustomer = () => {
    setCustomer_type("C");
    setOpenCustomerSelector(true);
  };
  const onCloseCustomerSelectDialog = () => {
    setOpenCustomerSelector(false);
    setValue(0);
  };
  const handleCustomerSelection = (type: string) => {
    setCustomer_type(type);
    setOpenCustomerSelector(false);
  };
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    if (newValue === 2) {
      setOpenCustomerSelector(true);
    }
    setDataFlag(false);
    setNewDataFlag(false);
  };

  const getVoucherDetails = async (voucherNo: number) => {
    try {
      const result = await api.get(`item-return/${voucherNo}/items`);
      if (result !== undefined) {
        setVoucherData(result);
        setValue(1);
        setDataFlag(true);
      }
    } catch (e) {
      setSnackbarColor("red");
      setItemReturnStatus("Something went wrong");
    }
  };

  const getExchangeVoucherDetails = async (voucherNo: number) => {
    try {
      const result = await api.get(`item-return/${voucherNo}/exchange/items`);
      if (result !== undefined) {
        setVoucherData(result);
        setValue(5);
        setNewDataFlag(true);
      }
    } catch (e) {
      setSnackbarColor("red");
      setItemReturnStatus("Something went wrong");
    }
  };

  const getPrintDetails = async (ret_id: number) => {
    setReturnType("return");
    const itemReturnPrintDetails = await api.get(
      `item-return/itemReturnDetails-print/${ret_id}`
    );

    setPrintDetails(itemReturnPrintDetails);

    if (user.is_super_admin === true) {
      setOpenBarcodeDialog(true);
      setRePrint(true);
    } else {
      setOpenAuthenticationDialog(true);
    }
  };

  const getExchangePrintDetails = async (ret_id: number) => {
    setReturnType("exchange");
    const itemExchangePrintDetails = await api.get(
      `item-return/itemExchangeDetails-print/${ret_id}`
    );

    setExchangePrintDetails(itemExchangePrintDetails);

    if (user.is_super_admin === true) {
      setOpenBarcodeDialog(true);
      setRePrint(true);
    } else {
      setOpenAuthenticationDialog(true);
    }
  };

  const handleCloseAuthenticationDialog = () => {
    setOpenAuthenticationDialog(false);
  };

  const handleCloseBarcodeDialog = () => {
    setOpenBarcodeDialog(false);
  };

  const clearDataAfterPrint = () => {
    setOpenBarcodeDialog(false);
    setValue(0);
    // setDataFlag(false);
  };

  const handleCloseBarcodeDialogDisAgree = () => {
    // console.log("todo");
  };
  const handleCloseBarcodeDialogOk = () => {
    // console.log("todo");
  };

  const onAuthenticationCheck = async (credentials: any) => {
    try {
      const permissionObject = {
        username: credentials.username,
        password: credentials.password,
        privilege: "item_return",
        action: "edit",
      };
      let credentialResult = await api.post(
        `permissions/verify`,
        {},
        permissionObject
      );
      if (credentialResult === true) {
        setOpenBarcodeDialog(true);
        setRePrint(true);
      } else {
        setOpenBarcodeDialog(false);
      }
      return credentialResult;
    } catch (e) {
      console.log(e);
      throw e;
    }
  };

  const onCloseSnackbar = () => {
    setItemReturnStatus("");
  };

  return (
    <>
      <Helmet>
        <title>Item return</title>
      </Helmet>
      <Grid
        container
        spacing={2}
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <SnackBar
          status={itemReturnStatus}
          onCloseError={onCloseSnackbar}
          color={snackbarColor}
        />
        <Grid item xs={12} className={classes.root}>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab label="Item Return List" />
              <Tab
                label="Item Return VoucherList"
                style={{ display: dataFlag ? "" : "none" }}
              />
              <Tab
                label="Create Item Return"
                style={{ display: createPermission ? "block" : "none" }}
              />
              <Tab label="Item Return Voucher" />
              <Tab label="Item Exchange List" />
              <Tab
                label="Item Exchange VoucherList"
                style={{ display: newdataFlag ? "" : "none" }}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <ItemReturnDetailsTable getVoucherDetails={getVoucherDetails} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <ItemReturnVoucherList
              voucherData={voucherData}
              getPrintDetails={getPrintDetails}
              searchFlag={false}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <ItemReturn
              customer_type={customer_Type}
              resetCustomer={resetCustomer}
            />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <ItemReturnVoucher />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <ItemExchangeDetailsTable
              getVoucherDetails={getExchangeVoucherDetails}
            />
          </TabPanel>
          <TabPanel value={value} index={5}>
            <ItemExchangeVoucherList
              voucherData={voucherData}
              getPrintDetails={getExchangePrintDetails}
              searchFlag={false}
            />
          </TabPanel>
        </Grid>

        {openAuthenticationDialog ? (
          <AuthenticationDialog
            handleCloseAuthenticationDialog={handleCloseAuthenticationDialog}
            openAuthenticationDialog={openAuthenticationDialog}
            onAuthenticationCheck={onAuthenticationCheck}
          />
        ) : (
          ""
        )}

        {openBarcodeDialog ? (
          <BarcodeDialog
            openBarcodeDialog={openBarcodeDialog}
            type={return_type === "return" ? "return" : "exchange"}
            barcodeValue={""}
            handleCloseBarcodeDialog={handleCloseBarcodeDialog}
            printDetails={
              return_type === "return" ? printDetails : exchangePrintDetails
            }
            rePrint={rePrint}
            totalPrice={0}
            itemReturnDays={""}
            clearDataAfterPrint={clearDataAfterPrint}
            barcodeCancelConfirmationDialog={false}
            handleCloseBarcodeDialogAgree={handleCloseBarcodeDialogOk}
            handleCloseBarcodeDialogDisAgree={handleCloseBarcodeDialogDisAgree}
            isCreditCustomer={customer_Type === "R" ? true : false}
            handleClose={clearDataAfterPrint}
          />
        ) : (
          ""
        )}

        <CustomerSelectDialog
          openCustomerSelectDialog={isOpenCustomerSelector}
          onCancel={onCloseCustomerSelectDialog}
          onSelectCustomer={handleCustomerSelection}
          setCustomer_type={setCustomer_type}
          customer_type={customer_Type}
        />
      </Grid>
    </>
  );
};
